module.exports = __webpack_public_path__ + "static/media/loaderrtckpi.bef9749a.gif";